// extracted by mini-css-extract-plugin
export default {"social-icons":"Layout_social-icons__IZKIK","pulse":"Layout_pulse__XBpX+"};